// Marks a MAKC product image as decoded so it can fade in over its
// placeholder background (the paired CSS lives in assets/makc-tokens.css
// next to the fade rule, alongside this project's other two global
// rules). Loaded once site-wide from layout/theme.liquid, the same way
// assets/makc-scroll-lock.js is.
//
// The load event is not enough on its own, for two separate reasons:
//
// 1. A cached image can already be decoded before any listener attaches
//    -- its load event has been and gone, so it would sit at opacity 0
//    forever. img.complete plus a non-zero naturalWidth is the standard
//    test (naturalWidth rules out a broken image, which also reports
//    complete). Same check assets/makc-product-sheet.js already uses on
//    the card image it warms from.
// 2. The cart rebuilds every row on every repaint (itemsContainer
//    .innerHTML = '' in assets/makc-cart-shell.js) and search rebuilds
//    its rows on every keystroke, so these <img> elements are brand new
//    constantly. Because a decoded image is marked in the same task it
//    is created, its first computed style is already opaque and no
//    transition runs -- so the fade plays once, the first time a given
//    image decodes, and never again on a rebuild.
//
// An error also marks the image loaded: a broken image left at opacity 0
// would hide its own alt text.
//
// The fade is opt-in, gated on the class set on the first line below,
// so that this file is the single point of failure for it. The CSS
// starts every one of these images opaque; only once this script has
// actually run does the fade rule apply at all. If the asset 404s, is
// blocked, or throws before that line, every image simply shows --
// never the reverse, where a stylesheet that loaded without its script
// would leave the whole catalogue invisible.
document.documentElement.classList.add('makc-img-fade');

window.makcImageLoad = (function () {
  var LOADED_CLASS = 'is-loaded';

  // Only real product imagery fades. Every selector is qualified with
  // img so it can never match the non-image elements that share these
  // class names -- the cart's no-image placeholder and its skeleton rows
  // are both divs carrying .makc-cart__item-image, and fading those out
  // would hide the placeholder the fade is supposed to happen over.
  var SELECTORS = [
    'img.makc-menu-card__image-el',
    'img.makc-order-row-card__image-el',
    'img.makc-product-sheet__image-el',
    'img.makc-cart__item-image',
    'img.makc-search-takeover__thumb-image',
    // Added 2026-09-23: a real photo painting in over the
    // --makc-color-image-placeholder background its own component
    // already draws -- the same case as the five above. Neither is
    // rebuilt by JS, so the load-time scan() is all either needs.
    'img.makc-order-browse__poster',
    'img.makc-find-us__image'
  ].join(',');

  function markLoaded(img) {
    img.classList.add(LOADED_CLASS);
  }

  function watch(img) {
    if (!img || img.classList.contains(LOADED_CLASS)) return;
    if (img.complete && img.naturalWidth > 0) {
      markLoaded(img);
      return;
    }
    img.addEventListener('load', function () {
      markLoaded(img);
    }, { once: true });
    img.addEventListener('error', function () {
      markLoaded(img);
    }, { once: true });
  }

  function scan(root) {
    var scope = root || document;
    Array.prototype.forEach.call(scope.querySelectorAll(SELECTORS), watch);
  }

  // This file is deferred, so the document is already parsed when it
  // runs and this first scan catches every server-rendered image.
  // DOMContentLoaded is listened for as well because a deferred script
  // runs while readyState is "interactive", before that event (see
  // CLAUDE.md's platform notes), so a later-deferred script that prints
  // more markup is still covered. watch() is idempotent, so scanning
  // twice costs nothing.
  scan(document);
  document.addEventListener('DOMContentLoaded', function () {
    scan(document);
  });

  return {
    watch: watch,
    scan: scan
  };
})();
